import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import { HelmetProvider } from 'react-helmet-async';
// Temporarily comment out AuthProvider
// import { AuthProvider } from './context/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {/* Temporarily comment out AuthProvider */}
        {/* <AuthProvider> */}
          <HelmetProvider>
            <App />
          </HelmetProvider>
        {/* </AuthProvider> */}
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// Only call reportWebVitals once
reportWebVitals();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
